import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateNoteLazy = React.lazy(
	() => import(/* webpackChunkName : 'CreateNote' */ './components/CreateNote')
);

export default (store) => {
	return {
		path: 'home/teacher-notes/create-note',
		element: <AsyncLoading component={<CreateNoteLazy />} />,
	};
};
